import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { PageSchema } from '@/components/SEOSchema';
import { SITE_URL } from '@/lib/seo';

export default function DisclaimerPage() {
  const { t, i18n } = useTranslation();
  const homePath = i18n.language === 'pt' ? '/' : `/${i18n.language}/`;
  const disclaimerUrl = `${SITE_URL}${i18n.language === 'pt' ? '/disclaimer/' : i18n.language === 'de' ? '/de/haftungsausschluss/' : '/en/disclaimer/'}`;

  return (
    <div className="min-h-screen bg-background-50">
      <PageSchema
        type="WebPage"
        name={t('nav.disclaimer')}
        description="Read the disclaimer of the CSSBuy Spreadsheet Resource Hub: an independent resource, not affiliated with or endorsed by CSSBuy."
        url={disclaimerUrl}
        lang={i18n.language}
      />
      <Navbar />

      <div className="w-full px-4 md:px-6 lg:px-10 pt-24 pb-16">
        <div className="max-w-3xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
            <Link to={homePath} className="hover:text-primary-600 transition-colors">{t('nav.home')}</Link>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-foreground-600">{t('nav.disclaimer')}</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-semibold mb-8">{t('nav.disclaimer')}</h1>

          <div className="prose max-w-none space-y-6">
            <div className="bg-foreground-50 border border-foreground-200/50 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">Aviso Legal</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                This website is an independent informational resource and is not affiliated with, endorsed by, or operated by CSSBuy. All information provided on this website is for educational and informational purposes only.
              </p>
            </div>

            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">Independent Resource</h2>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                cssbuybr.sbs is an independent resource hub. We do not have any official partnership, affiliation, or endorsement relationship with CSSBuy or any other marketplace, seller, or platform mentioned on this website.
              </p>
              <p className="text-foreground-600 text-sm leading-relaxed">
                CSSBuy, sellers, marketplaces, and external links are operated by their respective parties. Information, prices, availability, shipping options, and policies may change at any time without notice.
              </p>
            </div>

            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">No Guarantees</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                We do not guarantee the accuracy, completeness, or timeliness of any information on this website. All users should verify information directly with the relevant platforms, sellers, and services before making any purchasing decisions. We are not responsible for any losses, damages, or issues arising from the use of information on this website.
              </p>
            </div>

            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">External Links</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                This website contains links to external websites. We are not responsible for the content, privacy policies, or practices of any third-party websites. Visiting external links is at your own risk.
              </p>
            </div>

            <div className="bg-white border border-background-200/60 rounded-xl p-6">
              <h2 className="text-xl font-semibold mb-3">Last Updated</h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                This disclaimer was last updated on 27 August 2026. We reserve the right to update this disclaimer at any time without prior notice.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}